import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Campaign } from '@mui/icons-material';

const Campaigns = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Campaigns
      </Typography>
      <Paper
        sx={{
          p: 8,
          textAlign: 'center',
          backgroundColor: '#f5f5f5'
        }}
      >
        <Campaign sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h5" color="textSecondary" gutterBottom>
          Feature Under Development
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Campaign management coming soon
        </Typography>
      </Paper>
    </Box>
  );
};

export default Campaigns;
